import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getSafevaultSiteUrls } from "../utils/safevaultSiteUrls";
import { SAFEVAULT_BRAND } from "../theme/safevaultBrand";
import { SAFEVAULT_TYPO } from "../theme/safevaultTypography";

export default function BlogNotFound() {
  const siteUrls = getSafevaultSiteUrls();

  return (
    <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
      <Typography
        component="p"
        sx={{
          fontFamily: SAFEVAULT_TYPO.fontFamily,
          ...SAFEVAULT_TYPO.bodySm,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: SAFEVAULT_BRAND.textMuted,
          mb: 2,
        }}
      >
        404 — Page not found
      </Typography>
      <Typography
        component="h1"
        sx={{
          fontFamily: SAFEVAULT_TYPO.fontFamily,
          ...SAFEVAULT_TYPO.section,
          color: SAFEVAULT_BRAND.deepPurple,
          mb: 2,
        }}
      >
        This blog page doesn&apos;t exist
      </Typography>
      <Typography
        sx={{
          fontFamily: SAFEVAULT_TYPO.fontFamily,
          ...SAFEVAULT_TYPO.body,
          color: SAFEVAULT_BRAND.textMuted,
          maxWidth: "36rem",
          mx: "auto",
          mb: 4,
        }}
      >
        The article or URL may have moved. Head back to the blog listing or visit the  marketing site.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
        <Button
          component={Link}
          to="/blog/"
          variant="contained"
          sx={{
            bgcolor: SAFEVAULT_BRAND.cliqTeal,
            fontFamily: SAFEVAULT_TYPO.fontFamily,
            fontWeight: 700,
            ...SAFEVAULT_TYPO.buttonSm,
            textTransform: "uppercase",
            "&:hover": { bgcolor: SAFEVAULT_BRAND.cliqTealHover },
          }}
        >
          Back to blogs
        </Button>
        <Button
          component="a"
          href={siteUrls.marketingHome}
          variant="outlined"
          sx={{
            borderColor: SAFEVAULT_BRAND.deepPurple,
            color: SAFEVAULT_BRAND.deepPurple,
            fontFamily: SAFEVAULT_TYPO.fontFamily,
            fontWeight: 600,
            "&:hover": { borderColor: SAFEVAULT_BRAND.deepPurple, bgcolor: "rgba(55,57,115,0.06)" },
          }}
        >
           home
        </Button>
      </Box>
    </Container>
  );
}
